import { useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import SuppliersService from "../Services/SuppliersService";
import { format, parseJSON } from "date-fns";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import SupplierProjectMailModel from "../Models/SupplierProjectMailModel";

interface SupplierMailsModalProps {
  code: string;
  afterCancel: Function;
}

const SupplierMailsModal = (props: SupplierMailsModalProps) => {
  const { instance } = useMsal();

  const suppliersService = useMemo(
    () => new SuppliersService(instance),
    [instance]
  );

  const [mails, setMails] = useState<SupplierProjectMailModel[]>([]);
  const [visible, setVisible] = useState<boolean>(true);

  useEffect(() => {
    async function loadData() {
      try {
        const data = await suppliersService.getMailsSentForSupplier(props.code);
        setMails(data);
      } catch (error) {
        toast.error("Fout bij het ophalen van de data.");
      }
    }

    loadData();
  }, [props.code, suppliersService]);

  function modalToggle() {
    setVisible(!visible);
    props.afterCancel();
  }

  return (
    <Modal isOpen={visible} toggle={modalToggle} size="lg" scrollable={true}>
      <ModalHeader toggle={modalToggle}>
        {props.code} - Mail geschiedenis
      </ModalHeader>
      <ModalBody>
        <table className="table table-sm text-nowrap">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Project</th>
            </tr>
          </thead>
          <tbody>
            {mails.map((record, index) => {
              return (
                <tr key={index}>
                  <td>{format(parseJSON(record.mailSentOn), "dd/MM/yyyy")}</td>
                  <td>{record.projectCode}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={modalToggle}>
          Sluiten
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SupplierMailsModal;
